/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Who_2Inputs */

const en_mk_abt_who_2 = /** @type {(inputs: Mk_Abt_Who_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That means every agent, every approval and every cost record you see on this site has been used by us first — usually some weeks before you see it.`)
};

const id_mk_abt_who_2 = /** @type {(inputs: Mk_Abt_Who_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artinya setiap agen, setiap approval, dan setiap catatan biaya yang Anda lihat di halaman ini sudah dipakai lebih dulu oleh kami sendiri — biasanya beberapa minggu sebelum Anda melihatnya.`)
};

/**
* | output |
* | --- |
* | "That means every agent, every approval and every cost record you see on this site has been used by us first — usually some weeks before you see it." |
*
* @param {Mk_Abt_Who_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_who_2 = /** @type {((inputs?: Mk_Abt_Who_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Who_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_who_2(inputs)
	return en_mk_abt_who_2(inputs)
});